/**
 * Facade for accessing the ONCE URL from the global window object.
 */

/**
 * Gets the ONCE URL from the global window object.
 *
 * @return {string} The ONCE URL as a string
 * @throws Error if the ONCE URL is not available in the global window object
 */
export function getOnceUrl(): string {
  if (!window.__APP__?.ONCE_URL) {
    throw new Error('ONCE URL is not available in window.__APP__.ONCE_URL');
  }

  return window.__APP__.ONCE_URL;
}
